<template>
	<div>

		<div class="w-100 account-header">
			<h2 class="mb-none">Notifications</h2>
			<em>If the switch is <strong><span class="text-success strong">green</span></strong>, you are opted-in.</em>
		</div>


		<hr class="solid mt-xs">
		
		<div v-if="user.hasPermission" class="mt-4">

			<div class="row">
				<div class="col-lg-4 form-group" v-for="n in user.notifications" :key="n.typeId">
					<el-switch v-model="n.isOptedIn"
										 active-color="#13ce66"
										 :active-text="n.name"
										 @change="handleChange(n, $event)"
										 inactive-color="#ff4949" style="top: 1px;">
					</el-switch>
				</div>
			</div>
			
			
			
			

			

		</div>

		
	</div>


</template>

<script>
	import { rest } from "@/utilities/rest.js";
	export default {
		name: "notifications",
		data() {
			return {
				form: false,
				data: {

				},
				serverError: null,
				thinking: {
					save: false				
				}
			}
		},

		
		methods: {

			handleChange(o, evt) {

				let payload = {
					typeId: o.typeId,
					isOptedIn: evt,
					userId: this.user.userId
				};

				rest.post("Account", "/UpdateNotifications", "json", JSON.stringify(payload)).done(response => {
					setTimeout(() => {
						this.$message.success("Changes have been saved.");
					}, 1000);
					
				}).always(() => {
					
				});
			}

			
		},

		props: ["user", "isViewingOwnProfile"]		

	}
</script>